import React, { Fragment }              from 'react';
import { Modal, Button }                from 'react-bootstrap';

import { ICON_CANCEL, ICON_INFO }       from '../../../../extras/icons';




const MotivoResorteo = props => {
    


    // ==========================================================================================
    // TOMO LOS PROPS ---------------------------------------------------------------------------
    // ==========================================================================================
    const { show, handleClose, datosJuez } = props;
    
    

    // ==========================================================================================
    // RENDERIZO --------------------------------------------------------------------------------
    // ========================================================================================== 
    return (
        <Modal 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleClose } 
            show = { show } 
            size = "md"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <ICON_INFO />&nbsp;
                    {   datosJuez!==''
                            ?
                                <strong>{ datosJuez.juez.apellido + ', ' + datosJuez.juez.nombre }</strong>
                            :
                                null
                    }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{'text-align':'center'}}>
                    <h4><strong>MOTIVO RESORTEO</strong></h4>
                    <br></br>
                    {   datosJuez!==''
                            ?
                                datosJuez.motivo.descripcion
                            :
                                null
                    }
                </div>
                {   datosJuez.observaciones
                        ?
                            <div style={{'margin-top':'20px', 'text-align':'justify'}}>
                                <strong>Observaciones: </strong>
                                { datosJuez.observaciones }
                            </div>
                        :
                            null
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    <ICON_CANCEL /> Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MotivoResorteo;
